/* loaded by smart-asset */
export default require("./assets/pallet-height.i.svg")